import i18n from "@/core/plugins/vue-i18n";
import i18nCore from "@shared/src/core/plugins/vue-i18n";

export const courierTypeSelection = [
	{
		id: 0,
		name: i18n.t('COMMON.TRANS_TYPE.LOGISTIC'),
		variant: "primary"
	},
	{
		id: 1,
		name: i18n.t('COMMON.TRANS_TYPE.COURIER'),
		variant: "info"
	}
]

export const instructionStatusSelection = [
	{
		id: 100,
		name: i18n.t('COMMON.STATUS.PENDING_ACKNOWLEDGE')
	},
	{
		id: 200,
		name: i18n.t('COMMON.STATUS.ACKNOWLEDGED')
	},
	{
		id: 300,
		name: i18n.t('COMMON.STATUS.REQUEST_REVERT')
	},
	{
		id: 400,
		name: i18n.t('COMMON.STATUS.REVERTED')
	}	,
	{
		id: 500,
		name: i18n.t('COMMON.STATUS.DONE')
	}
]

export const weekdaysSelection = function (locale) {
	let Weekdays = i18nCore.messages[locale].WEEKDAYS;
	return [
		{ value: 1, text: Weekdays.MONDAY },
		{ value: 2, text: Weekdays.TUESDAY },
		{ value: 3, text: Weekdays.WEDNESDAY },
		{ value: 4, text: Weekdays.THURSDAY },
		{ value: 5, text: Weekdays.FRIDAY },
		{ value: 6, text: Weekdays.SATURDAY },
		{ value: 0, text: Weekdays.SUNDAY },
	];
};

export const getDayDesc = function (locale, day) {
	let Weekdays = i18nCore.messages[locale].WEEKDAYS;
	let day_desc;
	if (day == "1") {
		day_desc = Weekdays.MONDAY;
	} else if (day == "2") {
		day_desc = Weekdays.TUESDAY;
	} else if (day == "3") {
		day_desc = Weekdays.WEDNESDAY;
	} else if (day == "4") {
		day_desc = Weekdays.THURSDAY;
	} else if (day == "5") {
		day_desc = Weekdays.FRIDAY;
	} else if (day == "6") {
		day_desc = Weekdays.SATURDAY;
	} else {
		day_desc = Weekdays.SUNDAY;
	}
	return day_desc;
};

export const ERROR_CODE_SELECTION = [
	{
		code: null,
		name: "All",
	},
	{
		code: "403",
		name: "FORBIDDEN (403)",
	},
	{
		code: "400",
		name: "BAD REQUEST (400)",
	},
	{
		code: "2001",
		name: "Bad Credentials (2001)",
	},
	{
		code: "2050",
		name: "Validation Exception (2050)",
	},
	{
		code: "-1",
		name: "Failed (-1)",
	},
	{
		code: "500",
		name: "Internal Server/Exception (500)",
	},
	{
		code: "200",
		name: "Success (200)",
	},
];

export const HOUR_RANGE_SELECTION = Array.from({ length: 11 }, (_, i) => ({
	value: i + 8,
	text: `${i + 8 < 10 ? '0' : ''}${i + 8}:00`
}));


export const PRINT_SIZES = {
	portrait: { h: 1075, w: 790 },
	landscape: { w: 1122, h: 729 },
	portrait_mm: { h: 297, w: 210 },
	landscape_mm: { w: 297, h: 210 },
	letter_half_mm: { h: 140, w: 216 }
}

export const FOOTER_PROPS = {
	"items-per-page-options": [10, 20, 50, 100, 500, 1000, -1],
	showCurrentPage: true
};

export const DATATABLE_OPTIONS = function (itemPerPage = 10) {
	return {
		page: 1,
		itemsPerPage: itemPerPage,
		sortBy: [],
		sortDesc: [],
		groupBy: [],
		groupDesc: [],
		multiSort: true,
		mustSort: true
	}
};


